import React from "react";
import { Alert } from "react-bootstrap";

const SXMobileWarning: React.FC = () => {
  return (
    <div className="mobile-warning-bg d-flex flex-column justify-content-center align-items-center text-center">
      <Alert variant="warning" className="mobile-warning">
        <Alert.Heading>This app is optimized for desktop</Alert.Heading>
        <p>For the best experience, please access this app from a device with a larger screen.</p>
      </Alert>
    </div>
  );
};

export default SXMobileWarning;
